import React from 'react';
import ProductMappingCard from './ProductMappingCard';
import ArtworkSection from './ArtworkSection';
import MapAllRemainingPanel from '../map-all-remaining-panel/MapAllRemainingPanel';
import ProductArtworkSection from './ProductArtworkSection';

const MappedVariantContainer = ({
    product,
    artworks,
    onRemap,
    onAddMoreDesign,
    onUploadArtwork,
    onRemoveArtwork,
    onApplyForChange,
    variants = [],
    onOpenMapAllModal,
    hasPriorityVariant,
    productArtWorks
}) => {
    const totalItems = artworks.reduce((total, artwork) => total + artwork.pieces_per_pack, 0)
    const productArtworks = productArtWorks?.artworks || [];
    // Calculate unmapped variants
    const unmappedVariants = variants.filter(v => !v.isMapped) || []
    // Only show panel if there's a valid priority variant (with shopify.available=true) and unmapped variants exist
    const shouldShowPanel = hasPriorityVariant && unmappedVariants.length >= 1

    return (
        <div className="MappedVariantContainer">
            {shouldShowPanel && (
                <MapAllRemainingPanel
                    unmappedCount={unmappedVariants.length}
                    onClick={onOpenMapAllModal}
                />
            )}

            <div className="section">
                <h2 className="sectionTitle">Map Merchize Product variants</h2>

                <ProductMappingCard
                    productImage={product?.image}
                    productName={product?.name}
                    sku={product?.sku}
                    options={product?.options}
                    onRemap={onRemap}
                    onAddMoreDesign={onAddMoreDesign}
                />
            </div>

            {(artworks?.length <= 0 && productArtworks?.length > 0) && <div className="section overflow-auto">
                <h2 className="sectionTitle">Product artwork</h2>
                <p className="sectionDescription">
                    You can use 1 set of artworks for many items. E.g. 5 items with same design.
                    Or you can add different set of artworks for each items.
                </p>
                <ProductArtworkSection artworks={productArtworks} />
            </div>}
            {(artworks?.length > 0) && <div className="section overflow-auto">
                <h2 className="sectionTitle">Artwork</h2>
                <p className="sectionDescription">
                    You can use 1 set of artworks for many items. E.g. 5 items with same design.
                    Or you can add different set of artworks for each items.
                </p>
                <ArtworkSection
                    artworks={artworks}
                    onUpload={onUploadArtwork}
                    onRemove={onRemoveArtwork}
                    onApplyForChange={onApplyForChange}
                />
                <p className="artworkSummary">
                    This variant includes: <b>{totalItems} item</b> with {artworks.length} different set of artworks
                </p>
            </div>}
        </div>
    );
};

export default MappedVariantContainer;
